import { css } from "@emotion/core";
import {
  color,
  fontSizes,
  fontTypes,
  fontWeight,
} from "../../constants/commons";
export const welcomeAboardPageStyle = css`
  .background-finalscreen-style {
    background: ${color.whitishGray};
  }
  .description-style {
    color: ${color.lightishBlue};
    font-family: ${fontTypes.meduim};
    font-weight: ${fontWeight.light};
    text-align: center;
  }
  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .title {
      color: ${color.black};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.md};
      font-weight: ${fontWeight.medium};
    }

    .welcome-aboard-padding-style {
      padding: 5em 0 0 0;
    }

    .video-container {
      .video-description-text {
        color: ${color.black};
        font-family: ${fontTypes.meduim};
        font-weight: ${fontWeight.medium};
      }
      audio,
      video {
        border-radius: 0.625em;
        box-shadow: 0em 0.125em 0.3125em 0em ${color.shadow};
        height: 9.35em;
      }
      .video-button {
        font-size: ${fontSizes.xxs};
        img {
          width: 100%;
        }
      }
      position: relative;
      button {
        position: absolute;
        border-radius: 50%;
        padding: 1em 1em 1em 1.3em;
        left: 37%;
        bottom: 45%;
        background: white;
        cursor: pointer;
        color: ${color.red};
        border: none;
        img {
          margin: 0;
        }
      }
    }
  }
  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .title {
      color: ${color.black};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.lg};
      font-weight: ${fontWeight.medium};
    }
    .welcome-aboard-padding-style {
      padding: 5em 0 0 0;
    }
    .video-container {
      .video-description-text {
        color: ${color.black};
        font-family: ${fontTypes.meduim};
        font-weight: ${fontWeight.medium};
      }
      audio,
      video {
        border-radius: 10px;
        box-shadow: 0em 0.125em 0.3125em 0em ${color.shadow};
        height: 10em;
      }
      .video-button {
        font-size: ${fontSizes.xxs};
        img {
          width: 100%;
        }
      }
      position: relative;
      button {
        position: absolute;
        border-radius: 50%;
        padding: 1em 1em 1em 1.3em;
        left: 37%;
        bottom: 45%;
        background: white;
        cursor: pointer;
        color: ${color.red};
        border: none;
        img {
          margin: 0;
        }
      }
    }
  }
  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .welcome-aboard-padding-style {
      padding: 5em 0 0 0;
    }
    .title {
      color: ${color.black};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.xlg};
      font-weight: ${fontWeight.medium};
    }
    .video-container {
      .video-description-text {
        color: ${color.black};
        font-family: ${fontTypes.meduim};
        font-weight: ${fontWeight.medium};
      }
      audio,
      video {
        border-radius: 0.625em;
        box-shadow: 0em 0.125em 0.3125em 0em ${color.shadow};
        height: 12em;
      }
      .video-button {
        font-size: ${fontSizes.xxs};
        border-radius: 2em;
        position: absolute;
        left: 9%;
        bottom: 12%;
        padding: 1em;
        img {
          width: 10%;
        }
      }
      position: relative;
      button {
        position: absolute;
        border-radius: 50%;
        padding: 1em 1em 1em 1.3em;
        left: 37%;
        bottom: 45%;
        background: white;
        cursor: pointer;
        color: ${color.red};
        border: none;
        img {
          margin: 0;
        }
      }
    }
  }
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    .title {
      color: ${color.black};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.xxlg};
      font-weight: ${fontWeight.medium};
    }
    .video-container {
      .video-description-text {
        color: ${color.black};
        font-family: ${fontTypes.meduim};
        font-weight: ${fontWeight.medium};
      }
      audio,
      video {
        border-radius: 0.625em;
        box-shadow: 0em 0.125em 0.3125em 0em ${color.shadow};
        height: 15em;
      }
      .video-button {
        font-size: ${fontSizes.xxs};
        position: absolute;
        left: 9%;
        bottom: 12%;
        padding: 1em;
        border-radius: 2em;
        img {
          width: 10%;
        }
      }
      position: relative;
      button {
        position: absolute;
        border-radius: 50%;
        padding: 1em 1em 1em 1.3em;
        left: 37%;
        bottom: 45%;
        background: white;
        cursor: pointer;
        color: ${color.red};
        border: none;
        img {
          margin: 0;
        }
      }
    }
  }
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .title {
      color: ${color.black};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.xxlg};
      font-weight: ${fontWeight.medium};
    }
    .video-container {
      .video-description-text {
        color: ${color.black};
        font-family: ${fontTypes.meduim};
        font-weight: ${fontWeight.medium};
      }
      audio,
      video {
        border-radius: 0.625em;
        box-shadow: 0em 0.125em 0.3125em 0em ${color.shadow};
        height: 13em;
      }
      .video-button {
        font-size: ${fontSizes.xxs};
        margin: 0 0 1em 0;
        img {
          width: 13%;
        }
      }
      position: relative;
      button {
        position: absolute;
        border-radius: 2em;
        padding: 0.75em 1.25em;
        left: 1.06em;
        bottom: 1.67em;
        background: white;
        cursor: pointer;
        color: ${color.red};
        border: none;
        font-family: ${fontTypes.bold};
        display: flex;
        align-items: flex-start;
        img {
          margin: 0 0.5em 0 0;
        }
      }
    }
  }
`;
